import 'react-hot-loader';
import 'antd/dist/antd.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { FBProvider } from './hooks/useFB';
import { DataStoreProvider } from './hooks/useDataStore';

ReactDOM.render(
  <FBProvider>
    <DataStoreProvider>
      <App />
    </DataStoreProvider>
  </FBProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
